import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/24/solid';
import React, { forwardRef, useState } from 'react';
import { PrimaryInputInterface } from '../../types/misc';

const PrimaryPasswordInput = forwardRef<HTMLInputElement, PrimaryInputInterface>((props, ref) => {
	const [showPassword, setShowPassword] = useState<boolean>(false);

	const [currentValue, setCurrentValue] = useState<string | null>(null);

	const handlePasswordToggle = () => {
		setShowPassword(!showPassword);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (props.validate) {
			props.validate(e.currentTarget.value);
		}
		setCurrentValue(e.currentTarget.value === '' ? null : e.currentTarget.value);
	};

	return (
		<div className='my-2 flex flex-col'>
			{props.label && (
				<label className={`mx-4 text-xs flex ${currentValue ?? 'hidden'}`} htmlFor={props.name}>
					<span className='bg-gray-100 rounded-t-smd px-4 py-0.5'>{props.label}</span>
				</label>
			)}
				<div className='flex flex-row place-item-center relative gap-3'>
					<div
						className={`mr-16 absolute pointer-events-none right-0 h-full w-14 ${
							typeof props.value === 'string' && props.value.length > 0 ? null : ''
						}`}
					>
						<div
							className={`flex place-content-center place-items-center bg-mint-400 h-full rounded-r-lg ${
								!props.valid && 'hidden'
							}`}
						>
							<CheckIcon className='h-4 w-4' />
						</div>
					</div>
					<input
						id={props.name}
						className={`flex-grow focus:ring-0 ${
							props.disabled ? 'bg-gray-100 text-gray-300' : null
						} placeholder-gray-400 placeholder-opacity-70 border-2 border-gray-100 px-3 py-3 rounded-lg focus:outline-none placeholder:font-sans placeholder:tracking-normal ${
							!showPassword && 'font-mono tracking-widest'
						}`}
						placeholder={props.placeholder}
						required={props.required}
						disabled={props.disabled}
						name={props.name}
						ref={ref}
						type={showPassword ? 'text' : 'password'}
						onChange={(e) => handleChange(e)}
					/>
					<button
						type='button'
						onClick={handlePasswordToggle}
						className='p-3 bg-white border-2 border-gray-100 rounded-lg hover:bg-gray-100 hover:cursor-pointer'
					>
						{showPassword ? <EyeSlashIcon className='h-6 w-6' /> : <EyeIcon className='h-6 w-6' />}
					</button>
				</div>
		</div>
	);
});

export default PrimaryPasswordInput;
